module.exports = __webpack_public_path__ + "img/moviePoster.2102ce54.jpg";